import { FormInputTypes } from '@components/_old/dynamicForm';
import {
  EnhancedTableHeader,
  EnhancedTableHeaderType,
} from '@components/table/widgets/shared-with-old';
import { IListingFilterWidgetSection } from '@components/widgets/listing-filter-widget';
import { IAbstractRecord } from '@models';

export const headers: Record<string, EnhancedTableHeader> = {
  planConfigManagement_Clause_Name: {
    name: 'planConfigManagement_Clause_Name',
    title: 'Clause Name',
    type: EnhancedTableHeaderType.Clickable,
    callback: () => undefined,
  },
  Line_Name: {
    name: 'planConfigManagement_Clause_LineID',
    title: 'Line',
    type: EnhancedTableHeaderType.Link,
    urlTemplate: '/plan/lines/{lineId}',
    openUrlInNewTab: false,
  },
  planConfigManagement_Clause_ExternalCode: {
    name: 'planConfigManagement_Clause_ExternalCode',
    title: 'External Code',
    type: EnhancedTableHeaderType.Text,
  },
  planConfigManagement_Clause_Description: {
    name: 'planConfigManagement_Clause_Description',
    title: 'Description',
    type: EnhancedTableHeaderType.Text,
  },
  planConfigManagement_Clause_Status: {
    name: 'planConfigManagement_Clause_Status',
    title: 'Status',
    type: EnhancedTableHeaderType.Text,
  },
  planConfigManagement_Clause_createdOn: {
    name: 'planConfigManagement_Clause_createdOn',
    title: 'Created On',
    type: EnhancedTableHeaderType.Date,
  },
  planConfigManagement_Clause_modifiedOn: {
    name: 'planConfigManagement_Clause_modifiedOn',
    title: 'Modified On',
    type: EnhancedTableHeaderType.Date,
  },
};

export function filterSectionsContent(
  lovs: Record<string, Record<string, string>>,
  filterValues: IAbstractRecord
): IListingFilterWidgetSection[] {
  const newFilterSections: IListingFilterWidgetSection[] = [
    {
      title: 'Filters',
      inputs: {
        line: {
          name: 'line',
          title: 'Line',
          type: FormInputTypes.newmultiselect,
          value: filterValues?.line || [],
          placeholder: 'Line',
          triggerUpdate: true,
          selectOptions: { ...lovs.line },
        },
        status: {
          name: 'status',
          title: 'Status',
          type: FormInputTypes.newmultiselect,
          value: filterValues?.status || [],
          placeholder: 'Status',
          triggerUpdate: true,
          selectOptions: { ...lovs.status },
        },
        createdOn: {
          name: 'createdOn',
          title: 'Created On',
          type: FormInputTypes.newdaterange,
          value: filterValues?.createdOn || [],
          placeholder: 'Created On',
          triggerUpdate: true,
        },
      },
    },
  ];
  return newFilterSections;
}
